import * as React from 'react';
import {
  BaSeBreakpointContext,
  BaSeButton,
  BaSeShapeButton,
} from '@base/react';

export const ShowButtonsAction = ({
  download,
  loadingDownload,
  print,
  isDisabled = false,
  showModal = () => {},
}) => {
  const { inTablet } = React.useContext(BaSeBreakpointContext);

  return inTablet ? (
    <>
      <BaSeButton
        isDisabled={isDisabled}
        value="Compartilhar"
        leftIcon="share-alt"
        onClick={showModal}
        type="secondary"
      />
      <BaSeButton
        isDisabled={isDisabled}
        value="Exportar"
        leftIcon="share"
        onClick={download}
        isLoading={loadingDownload}
        type="secondary"
      />
      <BaSeButton
        value="Imprimir"
        leftIcon="print"
        onClick={print}
        type="secondary"
      />
    </>
  ) : (
    <>
      <BaSeShapeButton
        shape="square"
        nameIcon="share-alt"
        onClick={showModal}
        isDisabled={loadingDownload}
        type="secondary"
      />
      <BaSeShapeButton
        shape="square"
        nameIcon="share"
        onClick={download}
        isDisabled={loadingDownload}
        isLoading={loadingDownload}
        type="secondary"
      />
      <BaSeShapeButton
        shape="square"
        nameIcon="print"
        onClick={print}
        type="secondary"
      />
    </>
  );
};
